import { jsonApiVuex } from '@common/store/json-api-vuex';

export const privacyCookieScanner = jsonApiVuex(
  'privacy/cookie-scanner',
  {},
  { moduleName: 'privacy/cookieScanner/cookieScanner' }
);
